<template>
  <div
    class="ds-text-field"
    :class="{
      'ds-text-field--disabled': isDisabled,
      'ds-text-field--light': light
    }"
    @click="$emit('click', $event)"
  >
    <div class="ds-text-field__wrapper">
      <TagIcon
        v-if="icon"
        class="ds-text-field__icon w-5 h-5"
        :icon="icon"
        color="mono-medium"
      />
      <div
        v-else-if="prefix"
        class="ds-text-field__prefix"
      >
        {{ prefix }}
      </div>
      <ChevronDownIcon v-if="showArrow" class="ds-text-field__arrow" />
      <input
        :id="id"
        :type="type"
        :autocomplete="autocomplete"
        class="ds-text-field__input"
        :name="name"
        :value="modelValue"
        :placeholder="placeholder"
        :readonly="readonly"
        :min="min"
        :max="max"
        :step="step"
        :disabled="isDisabled"
        :inputmode="inputMode"
        :aria-invalid="isMarkedAsInvalid || hasErrors"
        :aria-label="ariaLabel || null"
        :pattern="pattern || null"
        :maxlength="maxlength"
        :style="{ paddingRight: `${suffixLength}px` }"
        :data-test-id="dataTestId"
        @input="$emit('input', $event.target.value)"
        @change="$emit('change', $event.target.value)"
        @blur="$emit('blur', $event)"
        @focus="$emit('focus', $event)"
        @keydown="$emit('keydown', $event)"
      >
      <div
        v-if="suffix || $slots.suffix"
        class="ds-text-field__suffix"
      >
        <div v-if="suffix">
          {{ suffix }}
        </div>
        <slot
          v-else
          name="suffix"
        />
      </div>
      <div
        v-if="$slots.suffixIcon"
        class="flex items-center absolute right-0 top-0 h-full mr-3"
      >
        <slot name="suffixIcon" />
      </div>
    </div>
    <FormCaption
      v-if="caption"
      type="info"
      class="mt-1"
    >
      {{ caption }}
    </FormCaption>
    <FormCaption
      v-if="hasErrors"
      type="invalid"
      class="mt-1"
      ref="errorCaption"
    >
      <span class="flex items-center h-full" v-html="firstError" />
    </FormCaption>
  </div>
</template>

<script>
import ChevronDownIcon from '@tagvenue/icons/24/bold/arrows/chevron-down.svg';

import TagIcon from '@/components/TagIcon.vue';

import htmlProps from '../htmlProps.js';
import commonProps from './common-props-mixin';
import FormCaption from './FormCaption.vue';
import validation from './validation-mixin';

export default {
  name: 'BaseInputField',
  emits: ['input', 'change', 'focus', 'blur', 'keydown', 'click'],
  mixins: [validation, commonProps, htmlProps],
  components: {
    TagIcon,
    FormCaption,
    ChevronDownIcon,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    modelValue: {
      type: [String, Number],
    },
    maxlength: {
      type: Number,
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    step: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    autocomplete: {
      type: String,
      default: null,
    },
    pattern: {
      type: String,
      default: '',
    },
    showArrow: {
      type: Boolean,
      default: false,
    },
    inputMode: {
      type: String,
      default: 'text',
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
